import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import InvoiceSyncItemTable from '@accounting-integrations/components/tables/invoice-sync-item-table/invoice-sync-item-table.vue';

@Component({
  name: 'bpc-invoice-sync-items',
  components: {
    'bpc-invoice-sync-item-table': InvoiceSyncItemTable,
  },
})
export default class InvoiceSyncItem extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
